import { render, staticRenderFns } from "./NewUploadImg.vue?vue&type=template&id=aad8bb1e&"
import script from "./NewUploadImg.vue?vue&type=script&lang=js&"
export * from "./NewUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./NewUploadImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports